import { render } from "./BorderedIconButton.vue?vue&type=template&id=33519258&scoped=true"
import script from "./BorderedIconButton.vue?vue&type=script&lang=js"
export * from "./BorderedIconButton.vue?vue&type=script&lang=js"

import "./BorderedIconButton.vue?vue&type=style&index=0&id=33519258&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33519258"]])

export default __exports__